module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_9016.78a10ae2.png";